import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useRouteMatch, Switch, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Header from 'components/ui/Header';

import RolesTab from './RolesTab';
import MembersTab from './MembersTab';
import InvitesTab from './InvitesTab';
import SectorsTab from './SectorsTab';

import FormInvitePage from './FormInvitePage';

const SettingsPage = () => {
  const { t } = useTranslation();
  const match = useRouteMatch();

  const { params } = match;

  const tabsIndexes = {
    members: 0,
    roles: 1,
    invites: 2,
  };

  return (
    <>
      <div className="d-flex flex-column justify-content-between">
        <Header>
          <h1 className="m-0 p-0 fw-lighter">Admin</h1>
        </Header>

        <div className="pt-3 pb-5">
          <Tabs defaultIndex={tabsIndexes[params.tab || 0]}>
            <div className="container">
              <TabList>
                <Tab>{t('admin.members.tab')}</Tab>
                <Tab>{t('admin.roles.tab')}</Tab>
                <Tab>{t('admin.invites.tab')}</Tab>
                <Tab>{t('admin.categories.tab')}</Tab>
              </TabList>
            </div>

            <div className="container mt-5">
              <TabPanel>
                <MembersTab />
              </TabPanel>

              <TabPanel>
                <RolesTab />
              </TabPanel>

              <TabPanel>
                <InvitesTab />
              </TabPanel>

              <TabPanel>
                <SectorsTab />
              </TabPanel>
            </div>
          </Tabs>
        </div>

        <Switch>
          <Route exact path="/admin/members/invite/new" children={<FormInvitePage backUrl={match.url} />} />
        </Switch>
      </div>
    </>
  );
};

export default SettingsPage;
